import router from './router'
import store from './store'
import NProgress from 'nprogress'
import 'nprogress/nprogress.css'
import { message } from 'ant-design-vue'

const whiteList = ['/login']

// 【新增】递归查找第一个有效路由的辅助函数
function findFirstValidRoute(routes, basePath = '') {
    for (const route of routes) {
        // 跳过隐藏路由和 404
        if (route.hidden || route.path === '*') continue

        // 解析完整路径
        let fullPath = route.path
        if (!fullPath.startsWith('/')) {
            // 处理相对路径拼接
            fullPath = basePath + (basePath.endsWith('/') ? '' : '/') + fullPath
        }

        // 如果有子菜单，递归查找
        if (route.children && route.children.length > 0) {
            const childPath = findFirstValidRoute(route.children, fullPath)
            if (childPath) return childPath
        } else {
            // 是叶子节点（菜单），返回路径
            return fullPath
        }
    }
    return null
}

router.beforeEach(async(to, from, next) => {
    NProgress.start()
    const hasToken = localStorage.getItem('token')

    if (hasToken) {
        if (to.path === '/login') {
            next({ path: '/' })
            NProgress.done()
        } else {
            const hasRoutes = store.state.hasLoadedRoutes

            if (hasRoutes) {
                // 访问根路径时直接进入第一个有效菜单，避免停留在空 Layout。
                if (to.path === '/') {
                    const firstRoute = findFirstValidRoute(store.state.routes)
                    if (firstRoute) {
                        next({ path: firstRoute, replace: true })
                    } else {
                        next({ path: '/404', replace: true })
                    }
                } else {
                    next()
                }
            } else {
                try {
                    const accessRoutes = await store.dispatch('GenerateRoutes')
                    
                    if (router.addRoutes) {
                        router.addRoutes(accessRoutes)
                    } else {
                        accessRoutes.forEach(r => router.addRoute(r))
                    }

                    // 登录后的首次导航直接进入业务菜单，不再先渲染空的根 Layout。
                    if (to.path === '/') {
                        const firstRoute = findFirstValidRoute(store.state.routes)
                        next({ path: firstRoute || '/404', replace: true })
                    } else {
                        next({ ...to, replace: true })
                    }
                } catch (error) {
                    await store.dispatch('Logout')
                    next(`/login?redirect=${to.path}`)
                    NProgress.done()
                }
            }
        }
    } else {
        if (whiteList.indexOf(to.path) !== -1) {
            next()
        } else {
            next(`/login?redirect=${to.path}`)
            NProgress.done()
        }
    }
})

router.afterEach(() => {
    NProgress.done()
})
